module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "c-counter__block u-inline-block u-valign-middle"
  }, [_c('span', {
    staticClass: "c-counter__number u-block u-color--gray-light u-bold t-text--xxl t-lspacing--sm",
    domProps: {
      "innerHTML": _vm._s(_vm.diff[0])
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "c-counter__label u-block t-text--xxs t-lspacing--md u-uppercase u-opacity--5"
  }, [_vm._v("days")])]), _vm._v(" "), _c('div', {
    staticClass: "c-counter__vline u-inline-block u-valign-middle"
  }), _vm._v(" "), _c('div', {
    staticClass: "c-counter__block u-inline-block u-valign-middle"
  }, [_c('span', {
    staticClass: "c-counter__number u-block u-color--gray-light u-bold t-text--xxl t-lspacing--sm",
    domProps: {
      "innerHTML": _vm._s(_vm.diff[1])
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "c-counter__label u-block t-text--xxs t-lspacing--md u-uppercase u-opacity--5"
  }, [_vm._v("hours")])]), _vm._v(" "), _c('div', {
    staticClass: "c-counter__vline u-inline-block u-valign-middle"
  }), _vm._v(" "), _c('div', {
    staticClass: "c-counter__block u-inline-block u-valign-middle"
  }, [_c('span', {
    staticClass: "c-counter__number u-block u-color--gray-light u-bold t-text--xxl t-lspacing--sm",
    domProps: {
      "innerHTML": _vm._s(_vm.diff[2])
    }
  }), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "c-counter__vline u-inline-block u-valign-middle u-hide@xs"
  }), _vm._v(" "), _c('div', {
    staticClass: "c-counter__block u-inline-block u-valign-middle u-hide@xs"
  }, [_c('span', {
    staticClass: "c-counter__number u-block u-color--gray-light u-bold t-text--xxl t-lspacing--sm",
    domProps: {
      "innerHTML": _vm._s(_vm.diff[3])
    }
  }), _vm._v(" "), _vm._m(1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "c-counter__label u-block t-text--xxs t-lspacing--md u-uppercase u-opacity--5"
  }, [_vm._v("min"), _c('span', {
    staticClass: "u-hide@xs"
  }, [_vm._v("utes")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "c-counter__label u-block t-text--xxs t-lspacing--md u-uppercase u-opacity--5"
  }, [_vm._v("sec"), _c('span', {
    staticClass: "u-hide@xs"
  }, [_vm._v("onds")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ab5061e6"}!./src/scripts/components/app-counter/template.html
// module id = 941
// module chunks = 0